<template>
  <div class="container confirm-info mx-auto">
    <div class="top-title ml-2">
      <h3>ロープライス・ギャランティー申請</h3>
    </div>
    <div class="mt-6 mb-6 divider"></div>
    <div class="main-content">
      <div class="head-title">
        <SectionContentTitle
          :lineType="lineType.horizontal"
          :titleContent="titleContent[0]"
        />
        <div class="description">
          ベネフィット・ステーションをよりおトクに使ってもらう為の制度です。ご予約されたプランの料金より、同じ内容で他社の料金が安かった場合さらに安い料金でご利用いただく事が出来ます。
        </div>
      </div>
      <div class="c-box p-4">
        <SectionContentTitle
          :lineType="lineType.vertical"
          :titleContent="titleContent[1]"
        />
        <div class="item-title">
          <div v-for="(item, index) in guideData" :key="`item-${index}`" class="content">
            <Title
              :number="item.number"
              :title="item.title"
              :description="item.description"
            />
          </div>
        </div>
        <div class="collapse-cs">
          <a-collapse v-model="activeKey" :expand-icon-position="expandIconPosition" :bordered="false">
            <a-collapse-panel key="1">
            <template slot="header">
              <div class="flex">
                <span class="self-center slot-header"></span>
                <span class="font-bold">申請方法</span>
              </div>
            </template>
            <ul class="title-collapse">
              <li class="title">
                ①申請は<span class="text-primary font-bold">Beneオリジナル</span>マークが表示されている国内宿泊プランでの予約成立が条件となります。<br>
                また比較対象プランが空室があり、予約可能な状態であることが申請の条件となります。<br>
                ※比較対象プランが審査確認時に満室の場合は対象外となります。<br>
                ※ベネ楽天トラベルなどのWEB申込専用プランは対象外となります。<br>
                ②申請は予約成立直後の受付となりますので、予めご了承ください。<br>
                ※申請フォームはWEBで予約完了後、所定の手続きを進めていただくと表示されます。それ以外の場合は、カスタマーセンターまでお問合せください。<br>
                ※申請期限は利用日前日の18：00迄となります。<br>
                ※利用日前日の18：00以降及び利用日当日の申請は、審査の対象とはなりません。<br>
                ③インターネット媒体以外の申請(広告・新聞等・チラシ・パンフレット等紙媒体)をご希望の場合は、原本の郵送もしくはFAXが必要となります。<br>
                ④申請は同一グループ（同一宿泊者）での予約記録に対して、1回のみとなります。<br>
                ⑤同じ宿泊日での、他施設の申請は受け付けておりません。<br>
                ※同一施設での重複予約中の申請も受け付けておりません。<br>
                ⑥利用日間近での利用の場合、即キャンセルチャージ対象となる場合がございますのでご注意ください。<br>
                又審査及び、適用対象外の場合でも、予約は継続となります。<br>
                ⑦申請は申告制ですので、会員様ご自身で比較対象プランをお選びいただく必要がございます。<br>
                ※弊社にて比較対象プランをお選びすることはございませんので、予めご了承ください。<br>
                ⑧WEB申請は予約成立直後のみとなりますので、予めご了承ください。<br>
                ※申請フォームはWEBで予約完了後、所定の手続きを進めていただくと表示されます。<br>
                電話での申請もご予約成立直後の受付のみとなります。ご予約完了後にお申し出ください。<br>
                ※18：00以降の申請は翌営業時間での審査となります。<br>
                なおカスタマーセンターへご連絡頂いた際の申請についても、本規約に同意されたものとみなします。<br>
                ⑨日本国以外の法人による運営サイトに掲載されているプランについては、その表示言語が日本語でかつ日本円で掲載されている場合に限ります。<br>
                また表示料金が為替相場により変動する場合においては、弊社確認時での料金で審査させていただきますので、予めご了承ください。<br>
                ※その他審査及び対象外規定については、本規約にのっとり準用いたします。
              </li>
            </ul>
            </a-collapse-panel>
            <a-collapse-panel key="2">
              <template slot="header">
                <div class="flex">
                  <span class="self-center slot-header"></span>
                  <span class="font-bold">審査について</span>
                </div>
              </template>
              <ul class="title-collapse">
                <li class="title">
                  ①申請内容を弊社にて確認を行いますが、料金やプラン内容が一致しない場合や、比較対象プランを確認できなかった場合は、審査の対象とならない場合がございますので、予めご了承ください。<br>
                  ②プランによっては料金が変動するプランもございます。その場合は弊社確認時の料金で審査させていただきます。<br>
                  審査の段階で対象プランが満室の場合は対象外となりますので予めご了承ください。<br>
                  ※18：00以降の申請は、翌営業時間【10：00～18：00】の確認となります。<br>
                  ③申請された比較対象プランが、Beneオリジナルプランの場合は審査対象となりません。<br>
                  ④宿泊プランは料理内容やお部屋の位置など多様でございますので、プラン内容の確認に時間がかかる場合がございます。<br>
                  ⑤審査は専属部署にて、本規定に沿い厳正に行います。
                </li>
              </ul>
            </a-collapse-panel>
            <a-collapse-panel key="3">
              <template slot="header">
                <div class="flex">
                  <span class="self-center slot-header"></span>
                  <span class="font-bold">審査による対象外規定</span>
                </div>
                </template>
              <ul class="title-collapse">
                <li class="title">
                  予約中のプランとの比較において、以下掲載するケースに該当する相違点がある場合は、ロープライス・ギャランティー適用の対象外となりますので、予めご了承ください。<br>
                  ※下記は一例でございます。宿泊プランは様々な種類がございますので、審査または適用の対象とならない場合もございます。
                </li>
                <li class="title font-bold">
                  ①販売形態
                </li>
                <span>
                  (1)募集型企画旅行プラン<br>
                  ※個人フリータイプ含め全てのツアープラン<br>
                  (2)宿泊前に決済（事前支払）が必要なプラン<br>
                  ※オンラインによるクレジットカード決済や銀行振込等<br>
                  (3)日本国以外の宿泊施設利用<br>
                  (4)コーポレート契約や有料制会員サイト掲載プラン、その他プロモーション向けプラン<br>
                  (5)宿泊を伴わない全てのプラン<br>
                  ※日帰り(デイユース)プランなど<br>
                  (6)個室客室の利用がない宿泊プラン<br>
                  ※リラクゼーションルーム利用等<br>
                  (7)キャッシュバックプラン<br>
                  (8)販売・予約が利用日当日限定のプラン<br>
                  (9)クーポンやチケット等の共同購入を目的とした割引販売をしているサイト<br>
                  (10)国または地方自治体による経済活性化・被災地復興支援などを目的とした助成金が投入されているプラン
                </span>
                <li class="title font-bold">
                  ②予約内容と比較対象プランに相違がある場合
                </li>
                <span>
                  (1)予約客室と比較対象プランの客室に相違がある場合<br>
                  （例1）客室種類の相違　和室と洋室の相違など<br>
                  （例2）グレードの相違　広さやベットサイズ、眺望や階層の相違など<br>
                  ※客室手配が「施設お任せ」など、最終的な客室手配内容が同一の客室条件となる可能性が存在する場合はこの限りではありません。<br>
                  (2)食事の条件に相違がある場合<br>
                  （例1）2食付の予約に対して、食事無のプランで申請等<br>
                  （例2）食事形態が会席とバイキングで相違がある場合<br>
                  （例3）同一のお食事スタイルであっても、そのグレード(内容)に差異がある場合<br>
                  (3)利用者人数で申込ができないプラン<br>
                  （例）大人3名からの予約条件に対し、利用者が大人2名の場合<br>
                  (4)利用客室数と、予約可能な客室数とが一致しない場合<br>
                  （例）2室以上からの予約受付に対し、1室利用の場合など<br>
                  (5)泊数に制限のあるプランで、かつ利用内容と一致しない場合<br>
                  （例1）1泊利用に対して連泊プランでの申請<br>
                  （例2）連泊利用に対して1泊限定プランでの申請<br>
                  （例3）同じ泊数利用だが、何れかの日程で満室の為予約できない場合
                </span>
                <li class="title font-bold">
                  ③予約に関して特定の申込制限があるプラン
                </li>
                <span>
                  (1)利用者の在住地が限定されている場合<br>
                  (2)学生限定・シニア等年齢制限のある場合<br>
                  (3)男性及び女性等性別制限のある場合<br>
                  (4)バースデイプラン<br>
                  (5)各種条件付きのモニター料金プラン<br>
                  ・宿泊後に体験レポート提出<br>
                  ・宿泊後にクチコミやツイッター投稿<br>
                  ・該当施設への初回利用に限定されていること<br>
                  (6)公共交通機関等、交通手段を限定している場合<br>
                  (7)子供受入不可プラン<br>
                  (8)ペット同伴不可の場合<br>
                  (9)滞在時間に制限があり、利用と副わない場合<br>
                  (10)期間限定のタイムセール等、予約受付が終了しているプラン<br>
                  (11)予約受付に早期締切の制限や、予約成立後の変更・CXLが原則行えないプラン　<br>
                  ※早割りなど
                </span>
                <li class="title font-bold">
                  ④その他　適用外のケース
                </li>
                <span>
                  (1)各社固有の提供サービスや特典・金券は適用外となります。<br>
                  (2)各プラン固有の特典・金券は適用外となります。<br>
                  (3)ビジター様の利用料金は適用外となります。<br>
                  (4)現地直接予約や提携外手配に対する申請は受付けておりません。<br>
                  (5)連続7泊以上、7泊目からの宿泊は対象外となります。<br>
                  (6)掲載・設定ミス等、施設の意図に反した販売がなされていた場合は適用外となります。<br>
                  (7)添い寝等施設使用料や宿泊に伴う各種諸税は適用外となります。<br>
                  (8)比較対象プランの合計料金が、弊社利用料金より高い場合は審査の対象外となります。<br>
                  (9)比較対象プランが満室の場合<br>
                  ※比較対象プランの利用日が除外日の場合も該当します。<br>
                  (10)決済が日本円以外の場合<br>
                  (11)Beneオリジナルマークがない宿泊プランをご予約の場合は審査対象外となります。<br>
                  ※ベネ楽天トラベル、その他の宿泊予約サイトの宿泊プラン、海外宿泊、ツアーも対象外に含みます。
                </span>
              </ul>
            </a-collapse-panel>
          </a-collapse>
        </div>
      </div>
      <SectionContentTitle
        :lineType="lineType.horizontal"
        :titleContent="titleContent[2]"
      />
      <div class="c-box p-4">
        <Item :data="dataItemOrder" />
        <div>
          <SectionContentTitle
            :lineType="lineType.vertical"
            :titleContent="titleContent[3]"
          />
          <div class="box-content">
            <div class="style-div">
              <span class="title font-bold">宿泊期間</span>
              <span class="results">{{useDate}} {{nightCnt}}泊 {{roomCnt}}部屋 (大人{{totalAdult}}名/子ども{{totalChild}}名)</span>
            </div>
            <div class="style-div">
              <span class="title font-bold">チェックイン</span>
              <span class="results">{{lastCheckInTm}}</span>
            </div>
            <div class="style-div">
              <span class="title font-bold">部屋タイプ</span>
              <span class="results">{{typeOfRoom}}</span>
            </div>
          </div>
        </div>

        <div v-for="(item, index) in stayRoomDayPrtic" :key="`room-${index}`"> 
          <span class="title font-bold">{{index+1}}部屋目</span> 
          <div>
            <div class="flex mt-4" v-if="item.adultTotalHeadCnt + item.chldHeadCnt> 0">
              <div class="w-1/6">
                <span class="title">会員</span> 
              </div>
              <div class="w-5/6">

                <div class="flex justify-between" v-if="item.adultManHeadCnt">
                  <div class="item">
                    <span class="results mr-2">大人男性</span>
                    <span class="results">{{item.adultManHeadCnt}}名</span>
                  </div>
                  <div>
                    <span class="text-right">大人男性 {{item.adultMemberChrg ? item.adultMemberChrg : item.roomMemberChrg | formatCurrency}} x {{item.adultManHeadCnt}}名 = {{item.adultMemberChrg ? item.adultMemberChrg : item.roomMemberChrg * item.adultManHeadCnt | formatCurrency}}</span>
                  </div>
                </div>

                <div class="flex justify-between" v-if="item.adultWomanHeadCnt">
                  <div class="item">
                    <span class="results mr-2">大人女性</span>
                    <span class="results">{{item.adultWomanHeadCnt}}名</span>
                  </div>
                  <div>
                    <span class="text-right">大人女性 {{item.adultMemberChrg ? item.adultMemberChrg : item.roomMemberChrg | formatCurrency}} x {{item.adultWomanHeadCnt}}名 = {{item.adultMemberChrg ? item.adultMemberChrg : item.roomMemberChrg * item.adultWomanHeadCnt | formatCurrency}}</span>
                  </div>
                </div>

                <div class="flex justify-between" v-if="item.chldaHeadCnt">
                  <div class="item">
                    <span class="results mr-2">子ども 高学年</span>
                    <span class="results">{{item.chldaHeadCnt}}名</span>
                  </div>
                  <div>
                    <span class="text-right">子ども 高学年 {{item.chldaMemberChrg ? item.chldaMemberChrg : item.roomMemberChrg | formatCurrency}} x {{item.chldaHeadCnt}}名 = {{item.chldaMemberChrg ? item.chldaMemberChrg : item.roomMemberChrg * item.chldaHeadCnt | formatCurrency}}</span>
                  </div>
                </div>
                <div class="flex justify-between" v-if="item.chldbHeadCnt">
                  <div class="item">
                    <span class="results mr-2">子ども 低学年</span>
                    <span class="results">{{item.chldbHeadCnt}}名</span>
                  </div>
                  <div>
                    <span class="text-right">子ども 低学年 {{item.chldbMemberChrg ? item.chldbMemberChrg : item.roomMemberChrg | formatCurrency}} x {{item.chldbHeadCnt}}名 = {{item.chldbMemberChrg ? item.chldaMemberChrg : item.roomMemberChrg * item.chldbHeadCnt | formatCurrency}}</span>
                  </div>
                </div>
                <div class="flex justify-between" v-if="item.chldcHeadCnt">
                  <div class="item">
                    <span class="results mr-2">子ども 食事・布団付</span>
                    <span class="results">{{item.chldcHeadCnt}}名</span>
                  </div>
                  <div>
                    <span class="text-right">子ども 食事・布団付 {{item.chldcMemberChrg ? item.chldcMemberChrg : item.roomMemberChrg | formatCurrency}} x {{item.chldcHeadCnt}}名 = {{item.chldcMemberChrg ? item.chldcMemberChrg : item.roomMemberChrg * item.chldcHeadCnt | formatCurrency}}</span>
                  </div>
                </div>
                <div class="flex justify-between" v-if="item.chlddHeadCnt">
                  <div class="item">
                    <span class="results mr-2">子ども 食事のみ</span>
                    <span class="results">{{item.chlddHeadCnt}}名</span>
                  </div>
                  <div>
                    <span class="text-right">子ども 食事のみ {{item.chlddMemberChrg ? item.chlddMemberChrg : item.roomMemberChrg | formatCurrency}} x {{item.chlddHeadCnt}}名 = {{item.chlddMemberChrg ? item.chlddMemberChrg : item.roomMemberChrg * item.chlddHeadCnt | formatCurrency}}</span>
                  </div>
                </div>
                <div class="flex justify-between" v-if="item.chldeHeadCnt">
                  <div class="item">
                    <span class="results mr-2">子ども 布団のみ</span>
                    <span class="results">{{item.chldeHeadCnt}}名</span>
                  </div>
                  <div>
                    <span class="text-right">子ども 布団のみ {{item.chldeMemberChrg ? item.chldeMemberChrg : item.roomMemberChrg | formatCurrency}} x {{item.chldeHeadCnt}}名 = {{item.chldeMemberChrg ? item.chldeMemberChrg : item.roomMemberChrg * item.chldeHeadCnt | formatCurrency}}</span>
                  </div>
                </div>
                <div class="flex justify-between" v-if="item.chldfHeadCnt">
                  <div class="item">
                    <span class="results mr-2">子ども 食事・布団不要</span>
                    <span class="results">{{item.chldfHeadCnt}}名</span>
                  </div>
                  <div>
                    <span class="text-right">子ども 食事・布団不要 {{item.chldfMemberChrg ? item.chldfMemberChrg : item.roomMemberChrg | formatCurrency}} x {{item.chldfHeadCnt}}名 = {{item.chldfMemberChrg ? item.chldfMemberChrg : item.roomMemberChrg * item.chldfHeadCnt | formatCurrency}}</span>
                  </div>
                </div>

              </div>
            </div>

            <div class="flex mt-4" v-if="item.vistrAdultTotalHeadCnt + item.vistrChldHeadCnt > 0">
              <div class="w-1/6">
                <span class="title">ビジター</span> 
              </div>
              <div class="w-5/6">

                <div class="flex justify-between" v-if="item.vistrAdultManHeadCnt">
                  <div class="item">
                    <span class="results mr-2">大人男性</span>
                    <span class="results">{{item.vistrAdultManHeadCnt}}名</span>
                  </div>
                  <div>
                    <span class="text-right">大人男性 {{getVisitorPrice(item.adultMemberChrg, item.adultBoneSbsidChrg, item.roomMemberChrg) | formatCurrency}} x {{item.vistrAdultManHeadCnt}}名 = {{(getVisitorPrice(item.adultMemberChrg, item.adultBoneSbsidChrg, item.roomMemberChrg)) * item.vistrAdultManHeadCnt | formatCurrency}}</span>
                  </div>
                </div>

                <div class="flex justify-between" v-if="item.vistrAdultWomanHeadCnt">
                  <div class="item">
                    <span class="results mr-2">大人女性</span>
                    <span class="results">{{item.vistrAdultWomanHeadCnt}}名</span>
                  </div>
                  <div>
                    <span class="text-right">大人女性 {{getVisitorPrice(item.adultMemberChrg, item.adultBoneSbsidChrg, item.roomMemberChrg) | formatCurrency}} x {{item.vistrAdultWomanHeadCnt}}名 = {{(getVisitorPrice(item.adultMemberChrg, item.adultBoneSbsidChrg, item.roomMemberChrg)) * item.vistrAdultWomanHeadCnt | formatCurrency}}</span>
                  </div>
                </div>

                <div class="flex justify-between" v-if="item.vistrChldaHeadCnt">
                  <div class="item">
                    <span class="results mr-2">子ども 高学年</span>
                    <span class="results">{{item.vistrChldaHeadCnt}}名</span>
                  </div>
                  <div>
                    
                    <span class="text-right">子ども 高学年 {{getVisitorPrice(item.chldaMemberChrg, item.chldaBoneSbsidChrg, item.roomMemberChrg) | formatCurrency}} x {{item.chldaHeadCnt}}名 = {{ (getVisitorPrice(item.chldaMemberChrg, item.chldaBoneSbsidChrg, item.roomMemberChrg)) * item.chldaHeadCnt | formatCurrency}}</span>
                  </div>
                </div>
                <div class="flex justify-between" v-if="item.vistrChldbHeadCnt">
                  <div class="item">
                    <span class="results mr-2">子ども 低学年</span>
                    <span class="results">{{item.vistrChldbHeadCnt}}名</span>
                  </div>
                  <div>
                    <span class="text-right">子ども 低学年 {{getVisitorPrice(item.chldbMemberChrg, item.chldbBoneSbsidChrg, item.roomMemberChrg) | formatCurrency}} x {{item.chldbHeadCnt}}名 = {{(getVisitorPrice(item.chldbMemberChrg, item.chldbBoneSbsidChrg, item.roomMemberChrg)) * item.chldbHeadCnt | formatCurrency}}</span>
                  </div>
                </div>
                <div class="flex justify-between" v-if="item.vistrChldcHeadCnt">
                  <div class="item">
                    <span class="results mr-2">子ども 食事・布団付</span>
                    <span class="results">{{item.vistrChldcHeadCnt}}名</span>
                  </div>
                  <div>
                    <span class="text-right">子ども 食事・布団付 {{getVisitorPrice(item.chldcMemberChrg, item.chldcBoneSbsidChrg, item.roomMemberChrg) | formatCurrency}} x {{item.chldcHeadCnt}}名 = {{(getVisitorPrice(item.chldcMemberChrg, item.chldcBoneSbsidChrg, item.roomMemberChrg)) * item.chldcHeadCnt | formatCurrency}}</span>
                  </div>
                </div>
                <div class="flex justify-between" v-if="item.vistrChlddHeadCnt">
                  <div class="item">
                    <span class="results mr-2">子ども 食事のみ</span>
                    <span class="results">{{item.vistrChlddHeadCnt}}名</span>
                  </div>
                  <div>
                    <span class="text-right">子ども 食事のみ {{getVisitorPrice(item.chlddMemberChrg, item.chlddBoneSbsidChrg, item.roomMemberChrg) | formatCurrency}} x {{item.chlddHeadCnt}}名 = {{(getVisitorPrice(item.chlddMemberChrg, item.chlddBoneSbsidChrg, item.roomMemberChrg)) * item.chlddHeadCnt | formatCurrency}}</span>
                  </div>
                </div>
                <div class="flex justify-between" v-if="item.vistrChldeHeadCnt">
                  <div class="item">
                    <span class="results mr-2">子ども 布団のみ</span>
                    <span class="results">{{item.vistrChldeHeadCnt}}名</span>
                  </div>
                  <div>
                    <span class="text-right">子ども 布団のみ {{getVisitorPrice(item.chldeMemberChrg, item.chldeBoneSbsidChrg, item.roomMemberChrg) | formatCurrency}} x {{item.chldeHeadCnt}}名 = {{(getVisitorPrice(item.chldeMemberChrg, item.chldeBoneSbsidChrg, item.roomMemberChrg)) * item.chldeHeadCnt | formatCurrency}}</span>
                  </div>
                </div>
                <div class="flex justify-between" v-if="item.vistrChldfHeadCnt">
                  <div class="item">
                    <span class="results mr-2">子ども 食事・布団不要</span>
                    <span class="results">{{item.vistrChldfHeadCnt}}名</span>
                  </div>
                  <div>
                    <span class="text-right">子ども 食事・布団不要 {{getVisitorPrice(item.chldfMemberChrg, item.chldfBoneSbsidChrg, item.roomMemberChrg) | formatCurrency}} x {{item.chldfHeadCnt}}名 = {{(getVisitorPrice(item.chldfMemberChrg, item.chldfBoneSbsidChrg, item.roomMemberChrg)) * item.chldfHeadCnt | formatCurrency}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-2 mb-2 divider"></div>
        <div class="flex  justify-end ">
          <span class="mr-4 font-bold self-center" style="font-size:16px">
            宿泊料合計
          </span>
          <span class="font-bold" style="font-size:24px">{{totalAmount | formatCurrency}}</span>
        </div>
      </div>

      <SectionContentTitle
        :lineType="lineType.horizontal"
        :titleContent="titleContent[4]"
      />
      <div class="c-box p-4 mb-4">
        <div class="title-collapse ml-1">
          <div>
            下記申請項目をもれなくご記入の上、「申請内容を確認する」ボタンを押してください。<br>
             ※現在ご予約中の「Bene オリジナル」と表示されているプラン情報を入力しないでください。審査の対象となりません。 <br>
            ※入力情報は、弊社サイトに販売のない、比較サイトのプランをご入力ください。
          </div>
        </div>
        <div class="mt-6 mb-12 divider"></div>
        <div class="input-info">
          <div class="w-full mb-8">
            <div class="input">
                <div class="flex w-2/5">
                    <span class="w-1/2 font-bold">サイト名</span>
                    <span class="w-1/2">
                      <div class="category">必須</div>
                    </span>
                </div>
                <div class="type-input">
                  <div class="flex mb-2">
                      <a-input :maxLength="100" v-model.trim="contentRegister.siteName" placeholder="" />
                  </div>
                  <div class="alert-message">{{errorMessage.siteName}}</div>
                </div>
            </div>  
          </div>
          <div class="w-full mb-8">
            <div class="input">
                <div class="flex w-2/5">
                    <span class="w-1/2 font-bold">プラン名</span>
                    <span class="w-1/2">
                      <div class="category">必須</div>
                    </span>
                </div>
                <div class="type-input">
                  <div class="flex mb-2">
                      <a-input :maxLength="100" v-model.trim="contentRegister.planName" placeholder="" />
                  </div>
                  <div class="alert-message">{{errorMessage.planName}}</div>
                </div>
            </div>
          </div>
          <div class="w-full mb-8">
            <div class="input">
                <div class="flex w-2/5">
                    <span class="w-1/2 font-bold">部屋タイプ</span>
                    <span class="w-1/2">
                      <div class="category">必須</div>
                    </span>
                </div>
                <div class="type-input">
                  <div class="flex mb-2">
                      <a-input :maxLength="100" v-model.trim="contentRegister.typeRoom" placeholder="" />
                  </div>
                  <div class="alert-message">{{errorMessage.typeRoom}}</div>
                </div>
            </div>
          </div>
          <div class="w-full mb-8">
            <div class="input">
              <div class="flex w-2/5">
                  <span class="w-1/2 font-bold">朝食</span>
                  <span class="w-1/2">
                    <div class="category">必須</div>
                  </span>
              </div>
              <div class="type-input">
                <a-radio-group v-model="contentRegister.breakfast">
                  <a-radio class="mr-3" :value="0">
                    あり
                  </a-radio>
                  <a-radio :value="1">
                    なし
                  </a-radio>
                </a-radio-group>
                <div class="alert-message">{{errorMessage.breakfast}}</div>
              </div>
            </div>
          </div>
          <div class="w-full mb-8">
            <div class="input">
              <div class="flex w-2/5">
                <span class="w-1/2 font-bold">夕食</span>
                <span class="w-1/2">
                  <div class="category">必須</div>
                </span>
              </div>
              <div class="type-input">
                <a-radio-group v-model="contentRegister.dinner">
                    <a-radio class="mr-3" :value="0">
                      あり
                    </a-radio>
                    <a-radio :value="1">
                      なし
                    </a-radio>
                  </a-radio-group>
                  <div class="alert-message">{{errorMessage.dinner}}</div>
              </div>
            </div>
          </div>
          <div class="w-full mb-8">
            <div class="input">
              <div class="flex w-2/5">
                <span class="w-1/2 font-bold">料金</span>
                <span class="w-1/2">
                  <div class="category">必須</div>
                </span>
              </div>
              <div class="type-input">
                <div class="flex mb-2">
                    <a-input
                            :maxLength="13"
                            v-model.trim="contentRegister.amount"
                            placeholder=""
                            @change="onChangeTextInput"
                          />
                    <span class="mt-1 ml-2" >円</span>
                </div>
                <div class="alert-message">{{errorMessage.amount}}</div>
                <span>※大人1名あたりの料金をご入力ください。</span>
              </div>
            </div>
          </div>
          <div class="w-full mb-8">
            <div class="input">
              <div class="flex w-2/5">
                <span class="w-1/2 font-bold">サイトURL</span>
                <span class="w-1/2">
                  <div class="category">必須</div>
                </span>
              </div>
              <div class="type-input">
                <div class="flex mb-2">
                  <a-input v-model.trim="contentRegister.siteUrl" placeholder="" />
                </div>
                <div class="alert-message">{{errorMessage.siteUrl}}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-6 mb-6 divider"></div>
        <div>
          <div class="font-bold mb-3">
            料金の入力について
          </div>
          <p style="font-size:14px">
            ※料金は比較サイト上に掲載されている料金をそのままご入力ください。<br>
            ※各サイトによって、掲載料金がサービス料・消費税込み、サービス税込み・消費税別、サービス料・消費税別等、異なります。<br>
            ベネフィット・ステーションでは、サービス料、消費税込みで掲載しておりますので、各サイトのサービス料、消費税込み料金を弊社で確認の上、比較させていただきます。
          </p>
        </div>
        <div class="mt-8 mb-6 divider"></div>
        <div class="flex justify-center">
          <a-checkbox v-model="acceptTerm" />
          <span class="ml-4"
            >ロープライス・ギャランティー制度について確認の上、<a @click="gotoTerm" class="underline text-black" >ロープライス・ギャランティー規約</a>に同意します。</span
          >
        </div>
        <div class="flex gap-2 justify-center mt-4 mb-4">
          <button @click="handleBack" class="c-btn btn-white style-mw">
            <span class="">戻る</span>
          </button>
          <button @click="gotoConfirm" :disabled="!acceptTerm" :class="['c-btn btn-grey style-mw', styleButton]">
            <span class="">申請内容を確認する</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { Item, SectionContentTitle } from '@/components/compound'
import Title from './components/title'
import { GET_ORDER_DETAIL } from '@/store/modules/order/actions'
import moment from 'moment'
import func_utils from '@/mixins/func_utils'
import {
  SAVE_DATA_LOW_PRICE
} from '@/store/modules/bs_app/actions'
export default {
  name: 'BS_APP_03_001',
  mixins: [func_utils],
  components: {
    SectionContentTitle,
    Title,
    Item
  },
  data() {
    return {
      activeKey: [],
      expandIconPosition: 'right',

      titleContent: [
        'ロープライス・ギャランティー制度について',
        '申請手続きの流れ',
        '申請対象となるお申し込み情報',
        'お申し込み内容',
        '申請内容'
      ],
      lineType: { horizontal: 'h-line', vertical: 'v-line' },
      guideData: [
        {
          number: 1,
          title: 'まずはプランをチェック！',
          description:
            'ベネ・ステで宿泊予約をしようとしたところ、同じ内容で他サイトならもっとおトクになっているプランを発見！'
        },
        {
          number: 2,
          title: 'ロープライス・ギャランティーを申請！',
          description:
            '予約完了後、マイページのお申し込み履歴詳細画面より、ロープライス・ギャランティーを申請 <br>※予約完了後24時間以内の申請が対象となります。'
        },
        {
          number: 3,
          title: '申請に関する規定をチェック',
          description:
            'お手続きや審査に関する制度の説明画面へ進みますので、内容をご確認後、申請される場合は同意ボタンをクリック！'
        },
        {
          number: 4,
          title: '必要事項の入力',
          description:
            'ご予約いただいたプラン内容の下に、申請する情報を入力し送信してください。弊社担当部署にて申請内容を審査し、後日結果をご連絡します。'
        }
      ],
      dataItemOrder: {},
      planBasicInfo: null,
      acptNo: null,
      acceptTerm: false,
      styleButton: 'disabled-btn',
      useDate: null,
      nightCnt: 0,
      roomCnt: 0,
      stayDay: null,
      lastCheckInTm: null,
      stayRoomDayPrticLists: [],
      stayRoomDayPrtic: [],
      contentRegister: {
        siteName: '',
        planName: '',
        typeRoom: '',
        breakfast: null,
        dinner: null,
        amount: null,
        siteUrl: ''
      },
      errorMessage: {
        siteName: '',
        planName: '',
        typeRoom: '',
        breakfast: '',
        dinner: '',
        amount: '',
        siteUrl: ''
      },
      totalAmount: 0,
      acptDtlNo: null,
      acptPrticList: [],
      totalAdult: 0,
      totalChild: 0,
      typeOfRoom: null
    }
  },
  watch: {
    acceptTerm() {
      if (this.acceptTerm) {
        this.styleButton = 'btn-grey'
      } else {
        this.styleButton = 'disabled-btn'
      }
    }
  },
  computed: {
    getDataLowPrice() {
      return _.cloneDeep(_.get(this.$store.getters, 'bs_app.bs_app_03_001', null))
    },
    getAcceptTerm() {
      return _.cloneDeep(_.get(this.$store.getters, 'bs_app.bs_app_03_002', null))
    }
  },
  created() {

  },
  mounted() {
    this.getOrderDetail()
    if (this.getDataLowPrice) {
      this.contentRegister = this.getDataLowPrice.contentRegister
    }
    if(this.getAcceptTerm) {
      this.acceptTerm = _.get(this.getAcceptTerm, 'agreeTerm', null)
    }
  },
  methods: {
    onChangeTextInput(e) {
      const input = e.target.value
      this.contentRegister.amount = this.validateNumberHalfFullWidth(input)
    },
    getVisitorPrice(MemberChrg, BoneSbsidChrg, roomMemberChrg) {
      return MemberChrg ? MemberChrg + BoneSbsidChrg : roomMemberChrg
    },
    saveData() {
      const dataLowPrice = {
        contentRegister: this.contentRegister,
        dataItemOrder: this.dataItemOrder,
        acptNo: this.acptNo,
        acptDtlNo: this.acptDtlNo,
        stayRoomDayPrtic: this.stayRoomDayPrtic,
        useDate: this.useDate,
        stayDay: this.stayDay,
        nightCnt: this.nightCnt,
        roomCnt: this.roomCnt,
        checkOutTm: this.lastCheckInTm,
        totalAmount: this.totalAmount,
        totalAdult: this.totalAdult,
        totalChild: this.totalChild,
        typeOfRoom: this.typeOfRoom
      }
      this.$store.dispatch(SAVE_DATA_LOW_PRICE, dataLowPrice).then(() => {
        // console.log('save OK')
      })
    },
    gotoConfirm() {
      if (!this.validateForm()) {
        this.saveData()
        const query = this.$route.query
        this.$router.push({path: '/low-price-confirm', query})
      }
      
    },
    gotoTerm() {
      const query = this.$route.query
      this.saveData()
      this.$router.push({path: '/low-price-term', query})
    },
    handleBack() {
      this.$router.go(-1)
    },
    validateForm() {
      let hasError = false

      if (!this.contentRegister.siteName) {
        hasError = true
        this.errorMessage.siteName = 'サイト名を入力してください'
      } else {
        this.errorMessage.siteName = ''
      }

      if (!this.contentRegister.planName) {
        hasError = true
        this.errorMessage.planName = 'プラン名を入力してください'
      // } else if(!this.validateTextInput(this.contentRegister.planName)) {
      //   hasError = true
      //   this.errorMessage.planName = 'プラン名の形式が不正です。'
      } else {
        this.errorMessage.planName = ''
      }

      if (!this.contentRegister.typeRoom) {
        hasError = true
        this.errorMessage.typeRoom = '部屋タイプを入力してください'
      // }  else if(!this.validateTextInput(this.contentRegister.typeRoom)) {
      //   hasError = true
      //   this.errorMessage.typeRoom = '部屋タイプの形式が不正です。'
      } else {
        this.errorMessage.typeRoom = ''
      }

      if (!this.contentRegister.siteUrl) {
        hasError = true
        this.errorMessage.siteUrl = 'サイトURLを入力してください'
      } else if (this.validateURL(this.contentRegister.siteUrl)) {
        hasError = true
        this.errorMessage.siteUrl = '他社旅行会社URLは半角で入力してください。'
      } else {
        this.errorMessage.siteUrl = ''
      }

      if (!this.contentRegister.amount) {
        hasError = true
        this.errorMessage.amount = '料金を入力してください'
      } else {
        this.errorMessage.amount = ''
      }
      if (this.contentRegister.breakfast === null) {
        hasError = true
        this.errorMessage.breakfast = '朝食を選択してください'
      } else {
        this.errorMessage.breakfast = ''
      }
      if (this.contentRegister.dinner === null) {
        hasError = true
        this.errorMessage.dinner = '夕食を選択してください'
      } else {
        this.errorMessage.dinner = ''
      }

      return hasError
    },
    getOrderDetail() {
      const { acptNo } = this.$route.query
      this.acptNo = acptNo
      this.$store.dispatch(GET_ORDER_DETAIL, acptNo).then((data) => {
        if (data !== null) {
          const menuNo = _.get(data, 'orderStayDetail.acptDtlList[0].acptDtl.menuNo', '')
          const planId = _.get(data, 'orderStayDetail.acptDtlList[0].acptDtl.planId', '')
          const roomId = _.get(data, 'orderStayDetail.acptDtlList[0].acptPrticList[0].stayRoomDayPrticList[0].stayRoomDayPrtic.roomId', '')
          this.stayDay = _.get(data, 'orderStayDetail.acptDtlList[0].acptDtl.useDate', '')
          this.useDate = moment(_.get(data, 'orderStayDetail.acptDtlList[0].acptDtl.useDate', '')).format('YYYY年MM月DD日から') 
          this.nightCnt =  _.get(data, 'orderStayDetail.acptDtlList[0].stayAcptDtl.nightCnt', null)
          this.roomCnt =  _.get(data, 'orderStayDetail.acptDtlList[0].stayAcptDtl.roomCnt', null)
          this.acptPrticList = _.get(data, 'orderStayDetail.acptDtlList[0].acptPrticList', [])
          this.lastCheckInTm =  _.get(data, 'orderStayDetail.acptDtlList[0].othInfo.ckinSchDatetime', '')
          this.stayRoomDayPrticLists = _.get(data, 'orderStayDetail.acptDtlList[0].acptPrticList[0].stayRoomDayPrticList', '')
          this.totalAmount =  _.get(data, 'orderStayDetail.acpt.totalAmt', 0)
          this.acptDtlNo = _.get(data, 'orderStayDetail.acptDtlList[0].acptDtl.acptDtlNo', '')
          this.totalAdult = _.get(data, 'orderStayDetail.acptDtlList[0].stayAcptDtl.adultTotalHeadCnt', 0) + _.get(data, 'orderStayDetail.acptDtlList[0].stayAcptDtl.vistrAdultTotalHeadCnt', 0)
          this.totalChild = _.get(data, 'orderStayDetail.acptDtlList[0].stayAcptDtl.chldHeadCnt', 0) + _.get(data, 'orderStayDetail.acptDtlList[0].stayAcptDtl.vistrChldHeadCnt', 0)
          this.getStayRoomDayPrtic()
          this.getPlanDetail(menuNo, planId, roomId)
        }
      })
    },
    getStayRoomDayPrtic() {
      const stayRoomDayPrticList = []
      // eslint-disable-next-line no-unused-vars
      this.acptPrticList.forEach((ele, index) => {
        stayRoomDayPrticList.push(ele.stayRoomDayPrticList)
      })

      const stayRoomDayPrtic = []
      // eslint-disable-next-line no-unused-vars
      stayRoomDayPrticList.forEach((ele, index) => {
        stayRoomDayPrtic.push(ele[0].stayRoomDayPrtic)
      })
      this.stayRoomDayPrtic = stayRoomDayPrtic
    },
    getPlanDetail(menuNo, planId, roomId) {
      const query = this.$route.query
      this.$repositories('plan').getPlanDetail(menuNo, planId, roomId, query).then(
        (data) => {
          this.getPlanBasicInfo(data)
          this.typeOfRoom = _.get(data, 'roomBasicInfo.roomCondNm', '')
        })
    },
    getPlanBasicInfo(planDetail) {
      const planBasicInfo = planDetail ? planDetail.planBasicInfo : null
      if (planBasicInfo) {
        this.dataItemOrder = {
          type: 'type-small',
          menu_id: _.get(planBasicInfo, 'menuNo', ''),
          label: _.get(planDetail, 'menuInformation.categoryInfomation', ''),
          baseImg: _.get(planBasicInfo, 'planImages[0].imageUrl', ''),
          title1: _.get(planDetail, 'menuInformation.menuNm', ''),
          title2: _.get(planBasicInfo, 'planNm', '')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
.disabled-btn {
  background-color: #a5a8ab !important;
}
</style>
